/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowOutdoorMovieNightTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowOutdoorMovieNight,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Cinema Under the Stars!",
    "Movie Magic Outdoors!",
    "Let’s Watch a Flick!",
  ],
  title: "Outdoor Movie Night",
  description: "Organize a fun outdoor movie night.",
  longDescription:
    "Gather your friends for a magical outdoor movie experience! Choose a date, select the movie to watch, and plan the snacks!",
  emoji: "🎬",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Party,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Outdoor Movie Night",
          emoji: "🎬",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we have the outdoor movie night?",
          emoji: "📅",
          completeAction: {
            question: "Decide on which movie to watch?",
            description: "What movie do we want to see outdoors?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What movie should we watch?",
                emoji: "🍿",
                completeAction: {
                  question: "Decide on snacks and drinks?",
                  description: "What snacks and drinks should we bring?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What snacks should we bring?",
                      emoji: "🍕",
                    },
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What drinks should we have?",
                      emoji: "🥤",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Get Ready for Movie Night!",
    outroDescription:
      "Your outdoor movie night plans are set! Enjoy the show under the stars!",
  },
};
